import React from "react";
import AccountSelector from "./AccountSelector";

const GarageSelector = (props) => {
  return (
    <AccountSelector
      {...props}
      api="garages"
      type="garages"
      placeholder={props.placeholder || props.translate?.("searchGarage")}
    />
  );
};

export default GarageSelector;
